/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { MrfiktivHttpClientProvider } from "../mrfiktiv/mrfiktiv-http-client.provider";
import { FleetUsers } from "../mrfiktiv/v1/FleetUsers";
import {
  MrfiktivCreateUserDtoGen,
  MrfiktivFleetPermissionDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivPartnerFleetUserControllerFindAllByPartnerIdParamsGen,
  MrfiktivPartnerUserViewModelGen,
  MrfiktivUserIdentityViewModelGen
} from "../mrfiktiv/v1/data-contracts";

class PartnerFleetUserService {
  /**
   *
   */
  users: FleetUsers;

  /**
   *
   * @param mrfiktivHttpClientProvider
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.users = new FleetUsers(mrfiktivHttpClientProvider.client());
  }

  async create(
    partnerId: string,
    fleetId: string,
    data: MrfiktivCreateUserDtoGen
  ): Promise<MrfiktivPartnerUserViewModelGen> {
    return (await this.users.partnerFleetUserControllerCreate(partnerId, fleetId, data)).data;
  }

  async removePermission(
    partnerId: string,
    fleetId: string,
    userId: string,
    permission: MrfiktivFleetPermissionDtoGen[]
  ): Promise<MrfiktivPartnerUserViewModelGen> {
    return (await this.users.partnerFleetUserControllerRemovePermission(partnerId, fleetId, userId, { permission }))
      .data;
  }

  async addPermissions(
    partnerId: string,
    fleetId: string,
    userId: string,
    permission: MrfiktivFleetPermissionDtoGen[]
  ): Promise<MrfiktivPartnerUserViewModelGen> {
    return (await this.users.partnerFleetUserControllerAddPermission(partnerId, fleetId, userId, { permission })).data;
  }

  async findOne(partnerId: string, fleetId: string, userId: string): Promise<MrfiktivPartnerUserViewModelGen> {
    return (await this.users.partnerFleetUserControllerFindOneByPartnerId(partnerId, fleetId, userId)).data;
  }

  async findOneByName(partnerId: string, fleetId: string, username: string): Promise<MrfiktivPartnerUserViewModelGen> {
    return (await this.users.partnerFleetUserControllerFindOneByNameAndPartnerId(partnerId, fleetId, username)).data;
  }

  async findAll(
    query: MrfiktivPartnerFleetUserControllerFindAllByPartnerIdParamsGen
  ): Promise<MrfiktivPageViewModelGen & { data?: MrfiktivPartnerUserViewModelGen[] }> {
    return (await this.users.partnerFleetUserControllerFindAllByPartnerId(query)).data;
  }

  async invite(
    partnerId: string,
    fleetId: string,
    data: MrfiktivCreateUserDtoGen
  ): Promise<MrfiktivPartnerUserViewModelGen> {
    return (await this.users.partnerFleetUserControllerInvite(partnerId, fleetId, data)).data;
  }

  async getStatus(partnerId: string, fleetId: string, id: string): Promise<MrfiktivUserIdentityViewModelGen> {
    return (await this.users.partnerFleetUserControllerGetUserStatusByPartnerId(partnerId, fleetId, id)).data;
  }
}

export default new PartnerFleetUserService(new MrfiktivHttpClientProvider());
